export default function Card(theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.04)',
          border: '1px solid #E2E8F0',
          position: 'relative',
          zIndex: 0,
          transition: 'box-shadow 0.2s ease, transform 0.2s ease',
          '&:hover': { boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps:     { variant: 'h6' },
        subheaderTypographyProps: { variant: 'body2' },
      },
      styleOverrides: { root: { padding: theme.spacing(2.5, 3, 0) } },
    },
    MuiCardContent: {
      styleOverrides: { root: { padding: theme.spacing(2.5, 3) } },
    },
  };
}
